module.exports = __webpack_public_path__ + "static/media/need-eat-healthier.0d24fcf1.jpg";